import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ItemSide from './item-side/ItemSide'
import LazyLoad from 'react-lazyload'

class OrderDesign extends Component {
    render() {
        const {designFront, designBack, designSleeves, designHood, ...rest} = this.props

        return (
            <td className='DesignFront'>
                <LazyLoad>
                    <div className='row no-gutters'>
                        <div className='col-6 p-1'>
                            <ItemSide {...rest} type='update-design' side='front' url={designFront}/>
                        </div>

                        <div className='col-6 p-1'>
                            <ItemSide {...rest} type='update-design' side='back' url={designBack}/>
                        </div>

                        <div className='col-6 p-1'>
                            <ItemSide {...rest} type='update-design' side='sleeves' url={designSleeves}/>
                        </div>

                        <div className='col-6 p-1'>
                            <ItemSide {...rest} type='update-design' side='hood' url={designHood}/>
                        </div>
                    </div>
                </LazyLoad>
            </td>
        )
    }
}

OrderDesign.defaultProps = {
    designFront: '',
    designBack: '',
    designSleeves: '',
    designHood: '',
}

OrderDesign.propTypes = {
    designFront: PropTypes.string,
    designBack: PropTypes.string,
    designSleeves: PropTypes.string,
    designHood: PropTypes.string,
}

export default OrderDesign
